import { AutogenModelCarrierRate, AutogenRowCarrierRate } from "./autogen/AutogenModelCarrierRate";

export class ModelCarrierRate extends AutogenModelCarrierRate<RowCarrierRate> {
    constructor() {
        super(RowCarrierRate);
    }
}

export class RowCarrierRate extends AutogenRowCarrierRate {
}